/* eslint-disable no-console */
import DeferredPaymentPopup from './deferred-payment-popup';
import CiPopup from './ci-popup';
import Save200Popup from './save-200-popup';
import SiteAbandonPopup from './site-abandon-popup';

const sitePopupManager = () => {
  DeferredPaymentPopup();
  CiPopup();
  Save200Popup();
  SiteAbandonPopup();
};

export default sitePopupManager;
/* eslint-enable no-console */
